import React from 'react';
import { Chip, Tooltip, Typography, type ChipProps } from '@mui/material';

const TIER_STYLES: Record<string, { bg: string; color: string }> = {
  standard: { bg: '#eef4fb', color: '#4068a0' },
  lite:     { bg: '#fff9f3', color: '#a6681f' },
};

const DEFAULT_STYLE = { bg: '#f4f4f5', color: '#60666d' };

const TIER_TOOLTIPS: Record<string, string> = {
  standard: 'Full Service Valet solution',
  lite: 'Software Only solution',
};

export interface TierChipProps {
  tier: string | null;
  size?: ChipProps['size'];
}

const TierChip: React.FC<TierChipProps> = ({ tier, size = 'small' }) => {
  if (!tier) return <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>--</Typography>;

  const style = TIER_STYLES[tier] ?? DEFAULT_STYLE;
  const tooltip = TIER_TOOLTIPS[tier] ?? '';

  const chip = (
    <Chip
      label={tier}
      size={size}
      sx={{
        height: 20,
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'capitalize',
        backgroundColor: style.bg,
        color: style.color,
        border: 'none',
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );

  if (!tooltip) return chip;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {chip}
    </Tooltip>
  );
};

export default TierChip;
